import gsap from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import ProductScene from '../3D/ProductScene';

class ScrollItem__BlockMoreProducts extends ScrollItem__BlockDefault {
    _gridIndex = -1;
    _items = [];
    _revealed = false;

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        // El grid encara no existeix aquí (es crea diferit, veure onShow) → _gridIndex es
        // queda a -1 fins que el block és a punt d'entrar en pantalla.

        const header = GetBy.class('block-more-products__header', this.item)[0];
        if (header) gsap.set(header, { opacity: 0, y: 20 });

        const itemEls = GetBy.class('block-more-products__item', this.item);
        for (let i = 0; i < itemEls.length; i++) {
            gsap.set(itemEls[i], { opacity: 0, y: 40 });
            this._items.push({ el: itemEls[i], index: i });
        }

        this.onShow = () => {
            if (this._revealed) return;
            this._revealed = true;

            super.showCb();

            // Creació diferida dels thumbnails (GLB+textura+material) just ara, no a l'inici
            // de la càrrega de la pàgina — veure comentari a ProductScene._initGridFor.
            this._gridIndex = ProductScene.ensureGrid(this.item);
            ProductScene.showTempGrid(this._gridIndex);

            if (header) {
                gsap.to(header, {
                    opacity: 1, y: 0, duration: 1, delay: 0.3, ease: 'power3.out',
                    onComplete: () => gsap.set(header, { clearProps: 'opacity,y' }),
                });
            }

            this._items.forEach(({ el, index }) => {
                gsap.to(el, {
                    opacity: 1, y: 0,
                    duration: 1,
                    delay: 0.5 + index * 0.12,
                    ease: 'power3.out',
                    onComplete: () => gsap.set(el, { clearProps: 'opacity,y' }),
                });
            });
        };

        this.onHide = () => {};

        this.onMove = () => {
            if (this._gridIndex >= 0) ProductScene.moveTempGrid(this._gridIndex, this.progress);
        };
    }
}

Scroll._registerClass('BlockMoreProducts', ScrollItem__BlockMoreProducts);

export default ScrollItem__BlockMoreProducts;
